const ApiAddress = 'https://notely-node.onrender.com'
// const ApiAddress = 'http://127.0.0.1:3030'

export default ApiAddress